const breakpointXL = 1760;

export { breakpointXL };
